module.exports = __webpack_public_path__ + "static/evergreen-corner-dialog-d1e33cceeaf0c8a1f9058586582ee2d8.png";